<div class="container-fluid pt-2 app">
  <div class="row">
    <div class="col pl-0 pr-0">
      <div class="card pl-2 pr-2 mt-2 border-0">

        <!-- Header Section -->
        <div class="row ml-0 mr-0 mb-2 p-2 rounded border-0 bg-secondary">
          <div class="col-xl-3 col-lg-3 col-md-4 col">
            <h3 class="h3 mb-0 pl-1 align-middle float-left text-truncate text-dark lh-40">
              {{ 'forms.title' | trans }}
            </h3>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 d-none d-md-block">
            <input type="text" placeholder="{{ 'forms.search.placeholder' | trans }}" [(ngModel)]="searchQuery"
              (input)="filterForms()" class="form-control h-40 mb-0" />
          </div>
          <div class="col-xl-2 col-lg-2 col-md-3 d-none d-md-block">
            <select [(ngModel)]="statusFilter" (change)="filterForms()" class="form-control h-40 mb-0">
              <option value="">{{ 'forms.filter.all' | trans }}</option>
              <option value="draft">{{ 'forms.status.draft' | trans }}</option>
              <option value="published">{{ 'forms.status.published' | trans }}</option>
              <option value="archived">{{ 'forms.status.archived' | trans }}</option>
            </select>
          </div>
          <div class="col-auto">
            <button (click)="createNewForm()" type="button" class="btn">
              <h6 class="btn-text lh-26 pl-3 pr-3">
                {{ 'forms.create.new' | trans }}
                <span class="material-icons btn-icon align-middle lh-20 f-18 ml-1 icon-color">
                  add
                </span>
              </h6>
            </button>
          </div>
        </div>

        <!-- Mobile Search & Filter -->
        <div class="row ml-0 mr-0 mb-2 d-block d-md-none">
          <div class="col p-0">
            <input type="text" placeholder="{{ 'forms.search.placeholder' | trans }}" [(ngModel)]="searchQuery"
              (input)="filterForms()" class="form-control h-40 mb-2" />
            <select [(ngModel)]="statusFilter" (change)="filterForms()" class="form-control h-40 mb-0">
              <option value="">{{ 'forms.filter.all' | trans }}</option>
              <option value="draft">{{ 'forms.status.draft' | trans }}</option>
              <option value="published">{{ 'forms.status.published' | trans }}</option>
              <option value="archived">{{ 'forms.status.archived' | trans }}</option>
            </select>
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="text-center p-4">
          <p class="mb-0 lh-25">{{ 'forms.loading' | trans }}</p>
        </div>

        <!-- Empty State -->
        <div *ngIf="!loading && filteredForms.length === 0" class="text-center p-4 bg-secondary rounded mt-2">
          <p class="mb-3 lh-25">{{ 'forms.empty.message' | trans }}</p>
          <button (click)="createNewForm()" type="button" class="btn">
            <h6 class="btn-text lh-20 pl-3 pr-3">
              {{ 'forms.create.first' | trans }}
            </h6>
          </button>
        </div>

        <!-- Forms List -->
        <div *ngIf="!loading && filteredForms.length > 0">
          <div *ngFor="let form of filteredForms" class="card p-2 mb-3 bg-secondary project-controller"
            [class.archived-form]="form.status === 'archived'">
            <div class="row">
              <!-- Name -->
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-8">
                <h6 class="lh-35 align-middle mb-0 font-weight-light text-dark cursor-default text-truncate"
                  [matTooltip]="form.name" matTooltipPosition="below" matTooltipShowDelay="500">
                  {{ form.name }}
                </h6>
              </div>

              <!-- Description -->
              <div class="col-xl-2 col-lg-2 col-md-3 d-none d-lg-block">
                <p class="lh-35 mb-0 cursor-default text-truncate" [matTooltip]="form.description || ''"
                  matTooltipPosition="below" matTooltipShowDelay="500">
                  {{ form.description || '—' }}
                </p>
              </div>

              <!-- Version & Status -->
              <div class="col-xl-2 col-lg-2 col-md-3 d-none d-md-block">
                <div class="lh-30 align-middle">
                  <span class="version-badge">v{{ form.version }}</span>
                  <span [class]="'status-badge status-' + form.status + ' ml-1'">
                    {{ form.status | titlecase }}
                  </span>
                </div>
              </div>

              <!-- Fields & Date -->
              <div class="col-xl-2 col-lg-2 d-none d-lg-block">
                <p class="lh-35 mb-0 f-15 text-truncate">
                  {{ getTotalFields(form) }} {{ 'forms.fields' | trans }} • {{ form.updatedAt | date: 'short' }}
                </p>
              </div>

              <!-- Actions -->
              <div class="col- pr-3 ml-auto">
                <div class="d-flex align-items-center">
                  <!-- Edit -->
                  <button type="button" class="btn-empty border-0 d-none d-md-block"
                    [matTooltip]="'forms.action.edit' | trans" matTooltipPosition="above" matTooltipShowDelay="500"
                    (click)="editForm(form)">
                    <span class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                      edit
                    </span>
                  </button>

                  <!-- Archive/Restore -->
                  <button *ngIf="form.status !== 'archived'" type="button"
                    class="btn-empty border-0 ml-1 d-none d-md-block" [matTooltip]="'forms.action.archive' | trans"
                    matTooltipPosition="above" matTooltipShowDelay="500" (click)="toggleArchive(form)">
                    <span class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                      archive
                    </span>
                  </button>
                  <button *ngIf="form.status === 'archived'" type="button"
                    class="btn-empty border-0 ml-1 d-none d-md-block" [matTooltip]="'forms.action.restore' | trans"
                    matTooltipPosition="above" matTooltipShowDelay="500" (click)="toggleArchive(form)">
                    <span class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                      unarchive
                    </span>
                  </button>

                  <!-- Duplicate -->
                  <button type="button" class="btn-empty border-0 ml-1 d-none d-md-block"
                    [matTooltip]="'forms.action.duplicate' | trans" matTooltipPosition="above" matTooltipShowDelay="500"
                    (click)="duplicateForm(form)">
                    <span class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                      content_copy
                    </span>
                  </button>

                  <!-- More options dropdown -->
                  <div class="dropdown dropleft ml-1">
                    <button type="button" class="btn-empty border-0 d-block d-md-none" data-toggle="dropdown"
                      [matTooltip]="'forms.action.more' | trans" matTooltipPosition="above" matTooltipShowDelay="500">
                      <span
                        class="material-icons portal-icon align-middle lh-35 center btn p-0 rounded-circle w-35 h-35">
                        more_vert
                      </span>
                    </button>
                    <div class="dropdown-menu" style="border-radius: 5px;">
                      <button class="dropdown-item" (click)="editForm(form)">
                        <div class="d-inline lh-25 align-middle">
                          {{ 'forms.action.edit' | trans }}
                          <span class="material-icons float-right">edit</span>
                        </div>
                      </button>
                      <button class="dropdown-item" (click)="duplicateForm(form)">
                        <div class="d-inline lh-25 align-middle">
                          {{ 'forms.action.duplicate' | trans }}
                          <span class="material-icons float-right">content_copy</span>
                        </div>
                      </button>
                      <button class="dropdown-item" (click)="toggleArchive(form)">
                        <div class="d-inline lh-25 align-middle">
                          {{ form.status === 'archived' ? ('forms.action.restore' | trans) : ('forms.action.archive' |
                          trans) }}
                          <span class="material-icons float-right">
                            {{ form.status === 'archived' ? 'unarchive' : 'archive' }}
                          </span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Error Alert -->
        <div *ngIf="errorMessage" class="alert alert-danger mt-2" role="alert">
          {{ errorMessage }}
        </div>

        <!-- Confirmation Alertbox -->
        <app-alertbox *ngIf="showconfirmarchive && formToArchive" [alerttype]="'confirm'" [alerticon]="'help'"
          [alerttext]="'forms.confirmarchive.title' | trans" [confirmmessage]="'forms.confirmarchive.message' | trans"
          [confirmButtonText]="'forms.archive' | trans" [cancelButtonText]="'forms.cancel' | trans"
          (confirmed)="onArchiveConfirmed()" (cancelled)="onArchiveCancelled()">
        </app-alertbox>

      </div>
    </div>
  </div>
</div>